<app-chat-tab-shell
    [contractId]="contractId()"
    [documentTypeId]="documentTypeId()"
    [projectId]="projectId()"
    [formQuestions]="formQuestions()"
    [selectedFormQuestionId]="selectedFormQuestionId()"
/>
